import axios from '../http.js'

//考试列表
function getExamList(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/queryMyExamPage',
    method: 'post',
    data: data
  })
}
//考试成绩列表
function getMyScoreList(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/queryMyScorePage',
    method: 'post',
    data: data
  })
}
//考试前检测
function startExamCheck(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/startExamCheck',
    method: 'post',
    params: data
  })
}
//开始练习前检测
function startPracticeCheck(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/startPracticeCheck',
    method: 'post',
    params: data
  })
}
//开始考试
function startExam(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/startExam',
    method: 'post',
    params: data
  })
}
//开始练习
function startPractice(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/startPractice',
    method: 'post',
    params: data
  })
}
//提交考试结果
function submitExamResult(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/submitExamResult',
    method: 'post',
    data: data
  })
}
//心跳检测：是否可以考试
function canExamHeartDetect(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/canExamHeartDetect',
    method: 'post',
    params: data
  })
}
//我的准入证分页
function queryUserAuthPage(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/queryUserAuthPage',
    method: 'post',
    data: data
  })
}
//查看考试结果
function showExamResult(data) {
  return axios.baseAxios({
    url: '/backstage/studentExam/showExamResult',
    method: 'post',
    params: data
  })
}

export default {
  getExamList,
  getMyScoreList,
  startExamCheck,
  startPracticeCheck,
  startExam,
  startPractice,
  submitExamResult,
  canExamHeartDetect,
  queryUserAuthPage,
  showExamResult
}


// WEBPACK FOOTER //
// ./src/api/modules/myExam.js